module.exports = __webpack_public_path__ + "img/solana.854e6476.svg";